import React from 'react';
import login from '@illustrations/auth/login.json';
import GeniebookLogo from '@assets/illustration/auth/geniebook-logo';
import { Link } from 'geniebook-ui/dist';
import AuthLayout from '@layouts/AuthLayout';
import './LoginPage.css';
import ArrowLeft from '@assets/icons/arrow-left';
import { useNavigate } from 'react-router-dom';
import ForgotPasswordCard from '@components/auth/ForgotPasswordCard';
import { Helmet } from 'react-helmet-async';
import {
  ContainerForm,
  PhoneIllustrationDiv,
  TabletIllustrationDiv,
} from './styles/Auth.style';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();

  return (
    <AuthLayout illustration={login}>
      <Helmet>
        <title>Geniebook - Forgot Password</title>
        <meta name="description" content="Forgot Password" />
      </Helmet>

      <div className="w-full">
        <TabletIllustrationDiv />
        <PhoneIllustrationDiv />
        <ContainerForm>
          <div className="text-left px-[38px] max-sm:px-[24px] lg:min-w-[343px]">
            <div
              className="forgot-back hover:forgot-back-hover cursor-pointer !flex text-left text-primary-apricot fill-current mb-[17px]"
              onClick={() => navigate('/')}
            >
              <ArrowLeft className="!w-[14px] mr-[4px]" />
              <Link className="text-[16px] !font-bold max-lg:hidden cursor-pointer">
                Back to login
              </Link>
              <Link className="back-mobile cursor-pointer text-[16px] font-bold hidden max-lg:block">
                Back
              </Link>
            </div>
            <div className="mb-[32px] lg:hidden">
              <GeniebookLogo className="w-[155px] h-[24px]" />
            </div>
            <div className="w-full">
              <ForgotPasswordCard />
            </div>
          </div>
        </ContainerForm>
      </div>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
